import { Injectable, inject } from "@angular/core";
import { CanActivate, Route, Router, UrlTree } from "@angular/router";
import { GlobalService } from "../serivces/global.service";
import { ToastrService } from "../serivces/toastr.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private toastrService = inject(ToastrService);

  permission = inject(GlobalService).permission;

  hasaccess(key: string): boolean {
    if (this.permission().includes(key)) {
      return true;
    }
    this.toastrService.error("Access Denied");
    // window.location.reload();
    return false;
  }

  async canActivate(): Promise<boolean | UrlTree> {
    const token = await sessionStorage.getItem("Token");
    if (!token) {
      // this.toastrService.error("Access Denied");
      this.router.navigate(["login"]);
      return false;
    }
    return true;
  }

  canMatch(route: Route): boolean {
    const data = route?.data?.["module"];
    return this.hasaccess(data);
  }
}
